import { defineStore } from "pinia";

export const useLoaderStore = defineStore("loaderStore", {
  state: () => ({
    loading: false,
    summaryLoading: false,
    technicalLoading: false,
    promoSection: false,
  }),
  getters: {
    getLoading: (state) => state.loading,
    getSummaryLoading: (state) => state.summaryLoading,
    getTechnicalLoading: (state) => state.technicalLoading,
  },
  actions: {
    setLoading(loading: boolean) {
      this.loading = loading;
    },
    setSummaryLoading(loading: boolean) {
      this.summaryLoading = loading;
    },
    setTechnicalLoading(loading: boolean) {
      this.technicalLoading = loading;
    },
    setPromoSectionLoading(loading: boolean) {
      this.promoSection = loading;
    },
  },
});
